import { getSurvey, submitAnswers } from './api.js'
import {
  getSurveyState,
  getFirstQuestionId,
  getCurrentQuestionId,
  getSecretToken,
  getAnswersByQuestionId,
  getCommentsByQuestionId,
  getCurrenOptionGroupChoices,
} from './selectors.js'

const routes = {
  'page/home': {
    path: '/',
    thunk: (dispatch, getState) => {
      const state = getState()
      const surveyState = getSurveyState(state)
      if (surveyState === 'fetched') navigateToQuestion(state, dispatch)
    },
  },

  'currentQuestionId/set': {
    path: '/answer/question/:questionId',
    thunk: (dispatch, getState) => {
      const state = getState()
      const surveyState = getSurveyState(state)
      if (surveyState === 'no-survey') {
        return dispatch({
          type: 'page/home',
        })
      }
    },
  },

  'surveyState/fetching': {
    path: '/answer/:secretToken/:firstAnswer*',
    thunk: async (dispatch, getState) => {
      try {
        const { secretToken, firstAnswer } = getState().location.payload
        const existingToken = getSecretToken(getState())
        if (existingToken === secretToken) {
          dispatch({ type: 'survey/fetched' })
          return navigateToQuestion(getState(), dispatch)
        }

        const survey = await getSurvey(secretToken)
        if (!survey) return dispatch({ type: 'surveyState/invalidToken' })

        dispatch({ type: 'survey/set', payload: { survey, secretToken } })
        navigateToQuestion(getState(), dispatch, true)

        if (firstAnswer !== undefined) {
          const firstQuestionId = getFirstQuestionId(getState())
          const answerAlternatives = getCurrenOptionGroupChoices(getState())
          if (answerAlternatives && answerAlternatives[firstAnswer]) {
            const { id, value } = answerAlternatives[firstAnswer]
            setTimeout(
              () =>
                dispatch({
                  type: 'answersByQuestionId/setAnswer',
                  payload: {
                    questionId: firstQuestionId,
                    answer: {
                      optionChoiceId: id,
                      value,
                    },
                  },
                }),
              500
            )
          }
        }
      } catch (err) {
        dispatch({ type: 'surveyState/fetchFailed' })
      }
    },
  },

  'formState/submit': {
    path: '/submit',
    thunk: async (dispatch, getState) => {
      const state = getState()
      const secretToken = getSecretToken(state)
      if (!secretToken) return dispatch({ type: 'page/home' })
      const answersByQuestionId = getAnswersByQuestionId(state)
      const commentsByQuestionId = getCommentsByQuestionId(state)
      try {
        await submitAnswers({
          secretToken,
          answersByQuestionId,
          commentsByQuestionId,
        })
        dispatch({ type: 'formState/submitted' })
      } catch (err) {
        dispatch({ type: 'formState/submitFailed', payload: err })
      }
    },
  },

  'formState/submitFailed': '/submit-failed',

  'formState/submitted': '/thanks',
}

function navigateToQuestion(state, dispatch, first) {
  const questionId = first
    ? getFirstQuestionId(state)
    : getCurrentQuestionId(state)
  dispatch({ type: 'currentQuestionId/set', payload: { questionId } })
}

export default routes



// WEBPACK FOOTER //
// ./src/routes.js